import { combineReducers } from 'redux';

import info from './info/infoReducer';

export default combineReducers({
	info,
});
